import inputClassFactory from '../inputClassFactory';
import compose from '../../hoc/compose';
import withValidation from '../../hoc/withValidation';
import template from './textInput.jsx';
import displayNames from '../displayNames';
export default compose(inputClassFactory(displayNames.TEXT_INPUT, template), [withValidation]);